export default __webpack_public_path__ + "static/media/header-image.b1c2bf9c.jpg";